import { Popconfirm } from 'antd';
import React, { useMemo } from 'react';
import { toCoef, toCurrency, toRate } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import DeleteButton from 'components/DeleteButton';
import { DataGridColDef } from 'components/DataGrid/DataGrid';

import { FormInstance } from 'antd/lib/form';
import { CheckSquareOutlined, BorderOutlined } from '@ant-design/icons';
import ModalControllerNV from 'components/ModalControllerNV';
import AttributeModal from './AttributeModal';
import { prFilteringCriteria } from 'services/pricing';
import { PropElementResponse } from 'services/proposal';

export type ElementAttributesTableProps = {
  onDeleteAttribute: (element: any) => void;
  attributes: any[];
  contract?: any;
  offerid?: any;
  form?: FormInstance;
  propsforcalculate?: any;
  onSaveAttribute?: (element: any, action: string) => void;
  debouncedCalculateNew?: () => void;
  currcode?: String;
  filtersList:prFilteringCriteria;
  priid:any;
  finElement:PropElementResponse;


};

const ElementAttributesTable = (props: ElementAttributesTableProps) => {
  const {
    onDeleteAttribute,
    attributes,
    onSaveAttribute,
    contract,
    offerid,
    form,
    propsforcalculate,
    currcode,
    filtersList,
    priid,
    finElement,
  } = props;

  // const handleOpenPaymentSchedule = (element: any) => {
  /** @todo */
  // };

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'elemAttribute.atttypelabel',
        dataIndex: 'atttypelabel',
        width: '20%',
      },
      {
        comcode: 'elemAttribute.attlabel',
        dataIndex: 'attlabel',
        width: '20%',
        render: (attlabel, record) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{attlabel}</a>
            )}
            modal={({ setVisible, visible }) => (
              <AttributeModal
                visible={visible}
                onClose={() => {
                  setVisible(false);
                }}
                onSave={onSaveAttribute}
                params={{
                  priid: priid,
                  filtersList: filtersList,
                  offerid: offerid,
                }}
                form={form}
                attribute={record}
                updateAttribute
                finElement={finElement}
              />
            )}
          ></ModalControllerNV>
        ),
      },

      {
        comcode: 'elemAttribute.attcodelabel',
        dataIndex: 'attcodelabel',
        width: '20%',
        render: (attcodelabel, record) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{attcodelabel}</a>
            )}
            modal={({ setVisible, visible }) => (
              <AttributeModal
                visible={visible}
                onClose={() => {
                  setVisible(false);
                }}
                onSave={onSaveAttribute}
                params={{
                  priid: priid,
                  filtersList: filtersList,
                  offerid: offerid,
                }}
                form={form}
                attribute={record}
                updateAttribute
                finElement={finElement}
              />
            )}
          ></ModalControllerNV>
        ),
      },

      {
        comcode: 'Element.tpname',
        dataIndex: 'tpname',
        width: '30%',
      },
      {
        comcode: 'Element.tprole',
        dataIndex: 'tprole',
        width: '10%',
        render: (value, record) =>
          record.serviceResponse?.tpname ??
          record.commissionResponse?.commlabel,
      },
      {
        comcode: 'Element.attmethodlabel',
        dataIndex: 'attmethodlabel',
        width: '20%',
      },

      {
        comcode: 'Element.attexternalreference',
        dataIndex: 'attexternalreference',
        width: '10%',
      },
      {
        comcode: 'attamount',
        dataIndex: 'attamount',
        render: (value, record) => toCurrency(record.attamount, currcode),
        width: '10%',
        align: 'right',
      },

      {
        comcode: 'attcoef',
        dataIndex: 'attcoef',
        render: (value, record) => toCoef(value),
        width: '10%',
        align: 'right',
      },
      {
        comcode: 'Element.attrate',
        dataIndex: 'attrate',
        render: (value, record) => toRate(value),
        width: '10%',
      },
      {
        comcode: 'Element.attnbdays',
        dataIndex: 'attnbdays',
        width: '10%',
      },

      {
        comcode: 'flagaddmanual',
        dataIndex: 'flagaddmanual',
        width: '20%',
        align: 'center',
        render: (value, record) =>
          record?.flagaddmanual ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },

      {
        comcode: 'flagupdate',
        dataIndex: 'flagupdate',
        width: '20%',
        align: 'center',

        render: (value, record) =>
          record?.flagupdate ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },
      {
        comcode: 'flagdelete',
        dataIndex: 'flagdelete',
        width: '20%',
        align: 'center',
        render: (value, record) =>
          record?.flagdelete ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },
      {
        comcode: 'Element.attstatuslabel',
        dataIndex: 'attstatuslabel',
        width: '20%',
        align: 'center',
        fixed: 'right',
      },

      {
        comcode: 'actions',
        key: 'operation',
        render: (text, record) => (
          <div>
            {record?.flagdelete && (
              <Popconfirm
                title="Do you want to delete this attribute?"
                onConfirm={() => onDeleteAttribute(record)}
              >
                <DeleteButton disabled={!record?.flagdelete} onlyIcon />
              </Popconfirm>
            )}
          </div>
        ),
        fixed: 'right',
        width: '20%',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      contract,
      attributes,
      onDeleteAttribute,
      onSaveAttribute,
      propsforcalculate,
    ]
  );

  return (
    <DataGrid
      scroll={{ x: 2500, y: 900 }}
      columns={columns}
      rowKey="attid"
      dataSource={attributes || []}
    />
  );
};

export default ElementAttributesTable;
